// Ported from vlookup-dramatic/components/logo.tsx by scripts/revamp/port-design.js
import React from "react";
import Image from "./image";
import Link from "./link";
import { cn } from "../lib/utils";
// Official vLookUp brand lockup, lifted from the production site's asset
// (vlookup-b2b-website/public/assets/images/logo.svg). Three variants live in
// /public/images, all sharing the same 172.19 x 50.85 viewBox so they render at
// identical glyph size for a given height:
//   vlookup-logo.svg        wordmark + tagline, near-black tagline (light panels)
//   vlookup-logo-light.svg  wordmark + tagline, white tagline (dark panels)
//   vlookup-wordmark.svg    wordmark only, no tagline
const ASPECT = 172.19 / 50.85;
export function Logo({ withTagline = true, light = false, height = 46, priority = false, className, }) {
    const src = withTagline
        ? light
            ? "/revamp/images/vlookup-logo-light.svg"
            : "/revamp/images/vlookup-logo.svg"
        : "/revamp/images/vlookup-wordmark.svg";
    return (<Link href="/" aria-label="vLookUp — Relevant connections for rising women" className={cn("inline-flex shrink-0 items-center", className)}>
      <Image src={src} alt="vLookUp" width={Math.round(height * ASPECT)} height={height} priority={priority} style={{ height, width: "auto" }}/>
    </Link>);
}
